export const discountConstants = {
  SELECT_ALL: "Select All",
  TOGGLE_TRADEIN_MODAL: "TOGGLE_TRADEIN_MODAL",
  DISCOUNT_EXPIRED: "Expired",
};
